var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgCompany = function SvgCompany(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 70,
    viewBox: "0 0 47 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.281.918 5.875 14.534v49.904h34.813V14.533L23.28.918Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.938,
    height: 2.188,
    x: 0.313,
    y: 63.438,
    fill: "#494949",
    rx: 1.094
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.188,
    height: 2.188,
    x: 4.688,
    y: 67.813,
    fill: "#494949",
    rx: 1.094
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.188,
    height: 63.438,
    x: 22.188,
    y: 2.188,
    fill: "#494949",
    rx: 1.094
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M5.03 22.36 22.045 9.08a.5.5 0 0 1 .722.113l.635.94a.5.5 0 0 1-.106.674L6.28 24.087a.5.5 0 0 1-.721-.114l-.636-.94a.5.5 0 0 1 .107-.674Zm0 8.75 17.014-13.28a.5.5 0 0 1 .722.113l.635.94a.5.5 0 0 1-.106.674L6.28 32.837a.5.5 0 0 1-.721-.114l-.636-.94a.5.5 0 0 1 .107-.674Zm0 8.75 17.014-13.28a.5.5 0 0 1 .722.113l.635.94a.5.5 0 0 1-.106.674L6.28 41.587a.5.5 0 0 1-.721-.114l-.636-.94a.5.5 0 0 1 .107-.674Zm0 8.75 17.014-13.28a.5.5 0 0 1 .722.113l.635.94a.5.5 0 0 1-.106.674L6.28 50.337a.5.5 0 0 1-.721-.114l-.636-.94a.5.5 0 0 1 .107-.674Zm0 8.75 17.014-13.28a.5.5 0 0 1 .722.113l.635.94a.5.5 0 0 1-.106.674L6.28 59.087a.5.5 0 0 1-.721-.114l-.636-.94a.5.5 0 0 1 .107-.674Zm3.007 6.256 13.995-10.793a.5.5 0 0 1 .718.114l.646.943a.5.5 0 0 1-.107.678L9.293 65.351a.5.5 0 0 1-.718-.113l-.645-.944a.5.5 0 0 1 .107-.678Z"
  }))));
};

export { SvgCompany as ReactComponent };
export default "/_next/static/media/company.90dd8732.svg";